// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AcceptedWithdrawAttestation } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Attestation/Withdraw/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useAcceptedWithdrawAttestations: () => UseQueryResult<
  TemplateContract<AcceptedWithdrawAttestation>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { bridgeOperator } = useParties();
  return useQuery({
    queryKey: ['queryAcceptedWithdrawalAttestations', bridgeOperator, offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryAcceptedWithdrawalAttestations(offset!, bridgeOperator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useAcceptedWithdrawAttestations;
